import { Calendar, CheckCircle, MapPin } from "lucide-react";
import styles from "./PostCheckout.module.css";

const Success = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.card}>
        <div className={styles.iconWrapperSuccess}>
          <CheckCircle size={64} />
        </div>
        <h1>Payment Successful!</h1>
        <p className={styles.subtitle}>
          Thank you for supporting Nupur Creations and ShelterHouse - an
          organization that envision a community free of homeless and domestic
          violence.
        </p>

        <div className={styles.eventMiniCard}>
          <div className={styles.infoRow}>
            <Calendar size={18} />
            <span>August 16, 2026</span>
          </div>
          <div className={styles.infoRow}>
            <MapPin size={18} />
            <span>Willard Middle School, Aldie</span>
          </div>
        </div>

        <div className={styles.instructions}>
          <h3>What's Next?</h3>
          <ul>
            <li>
              Check your email for the Stripe receipt and ticket confirmation.
            </li>
            <li>Your name will be on the guest list at the entrance.</li>
            <li>
              Present your email confirmation at the food station for
              pre-ordered meals.
            </li>
          </ul>
        </div>

        <button
          className={styles.primaryBtn}
          onClick={() => (window.location.href = "/")}
        >
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default Success;
